var exports = {
  "qr": "footer__9gRDKx",
  "bL": "footerWrapper__vtL0SV",
  "JU": "footerButtonWrapper__tJ-7L0",
  "wC": "footerButton__rfff9p",
  "od": "childrenStyling__k3JZmY",
  "YQ": "spacious__Sj10LU",
  "U0": "condensed__Q37MZr",
};

module.exports = exports;
